import type { ReactNode } from 'react'

type SectionCardProps = {
  title: string
  description?: ReactNode
  footer?: ReactNode
  children: ReactNode
}

export const SectionCard = ({
  title,
  description,
  footer,
  children,
}: SectionCardProps) => (
  <section>
    <div className="mb-4 flex items-start justify-between gap-3">
      <div className="space-y-1">
        <h2 className="text-md font-semibold tracking-tight text-[var(--app-text)]">
          {title}
        </h2>
        {description ? (
          <p className="text-sm leading-6 text-[var(--app-muted)]">
            {description}
          </p>
        ) : null}
      </div>
    </div>

    <div className="space-y-3">{children}</div>

    {footer ? <div className="shrink-0 mt-2">{footer}</div> : null}
  </section>
)
